import { render, staticRenderFns } from "./BaseViewOnlyText.vue?vue&type=template&id=548081dd"
import script from "./BaseViewOnlyText.vue?vue&type=script&lang=js"
export * from "./BaseViewOnlyText.vue?vue&type=script&lang=js"
import style0 from "./BaseViewOnlyText.vue?vue&type=style&index=0&id=548081dd&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports